import React, { ReactNode, useState } from "react";
import { Box, Collapse, Grid } from "@material-ui/core";

import ExpandedTitle from "./ExpandedTitle";

interface ExpandedContentProps {
  title?: string | ReactNode;
  children?: ReactNode;
  defaultExpanded?: boolean;
  withPadding?: boolean;
  withBorder?: boolean;
}

export default function ExpandedContent(props: ExpandedContentProps) {
  // Props
  const { title, children, defaultExpanded, withPadding, withBorder } = props;
  // State
  const [expanded, setExpanded] = useState(defaultExpanded !== undefined ? defaultExpanded : true);

  const handleExpandClick = () => {
    setExpanded((prevState) => !prevState);
  };

  return (
    <>
      <ExpandedTitle
        expanded={expanded}
        withPadding={withPadding}
        title={title}
        withBorder={withBorder}
        handleExpandClick={() => handleExpandClick()}
      />
      <Grid container>
        <Grid item xs={12}>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Box component="div">
              {children}
            </Box>
          </Collapse>
        </Grid>
      </Grid>
    </>
  );
}

ExpandedContent.defaultProps = {
  withPadding: true,
  defaultExpanded: true
};
